export default __webpack_public_path__ + "static/media/category_10.226bfe8e.png";